import React from 'react';
import PropTypes from 'prop-types';
import Text, { TEXT_COLOR, TEXT_SIZE } from '@components/Text';
import {
  Wrapper,
  Title,
  Body,
  Buttons,
  EndForAllButton,
  LeaveOnlyMeButton,
  CancelButton,
} from './styles';

const VideoChatV2LeaveOptions = ({
  titleText,
  bodyText,
  endForAllText,
  leaveOnlyMeText,
  cancelText,
  onClose,
  onSelect,
  icon,
}) => {
  const handleSelect = (value) => () => {
    onSelect(value);
    onClose();
  };

  return (
    <Wrapper>
      {icon}
      <Title>
        <Text size={TEXT_SIZE.T0} textColor={TEXT_COLOR.DARK_BLUE} weight='900'>
          {titleText}
        </Text>
      </Title>
      {bodyText && (
        <Body>
          <Text size={TEXT_SIZE.T3} textColor={TEXT_COLOR.DISABLED}>
            {bodyText}
          </Text>
        </Body>
      )}
      <Buttons>
        <EndForAllButton className='endForAllButton' onClick={handleSelect('end_for_all')}>
          {endForAllText}
        </EndForAllButton>
        <LeaveOnlyMeButton className='leaveOnlyMeButton' onClick={handleSelect('leave_only_me')}>
          {leaveOnlyMeText}
        </LeaveOnlyMeButton>
        <CancelButton className='cancelButton' onClick={handleSelect('cancel')}>
          {cancelText}
        </CancelButton>
      </Buttons>
    </Wrapper>
  );
};

VideoChatV2LeaveOptions.propTypes = {
  onClose: PropTypes.func,
  onSelect: PropTypes.func,
  titleText: PropTypes.node,
  bodyText: PropTypes.node,
  endForAllText: PropTypes.node,
  leaveOnlyMeText: PropTypes.node,
  cancelText: PropTypes.node,
  icon: PropTypes.node,
};

VideoChatV2LeaveOptions.defaultProps = {
  onClose: () => {},
  onSelect: () => {},
};

export default VideoChatV2LeaveOptions;
